<script lang="ts">
    import { WishlistsStorefrontValuesBrandingEntity } from "@apps/wishlist/entities/WishlistsStorefrontValuesBrandingEntity";
    import { setTypedContext } from "@lib/svelte-typed-context";

    import { wishlistThemeContextToken } from "./WIshlistThemeContextToken";

    export let branding: WishlistsStorefrontValuesBrandingEntity;
    export let className: string | undefined = undefined;
    export { className as class };

    const theme = branding.wishlistThemeSettings;

    setTypedContext(wishlistThemeContextToken, branding);
</script>

<div
    class={className}
    style:--gw-wl-wishlistThemeSettings-primaryColor={branding
        .wishlistThemeSettings.primaryColor}
    style:--gw-wl-wishlistThemeSettings-secondaryColor={branding
        .wishlistThemeSettings.secondaryColor}
    style:--gw-wl-wishlistIconSettings-heartColor={branding.wishlistIconSettings
        .heartColor}
    style:--gw-wl-wishlistIconSettings-backgroundColor={branding
        .wishlistIconSettings.backgroundColor}
    style:--gw-wl-wishlistButtonSettings-borderRadius={branding
        .wishlistButtonSettings.borderRadius}
    style:--gw-wl-wishlistButtonSettings-color={theme[
        branding.wishlistButtonSettings.color
    ]}
    style:--gw-wl-wishlistButtonSettings-fontColor={branding
        .wishlistButtonSettings.fontColor}
    style:--gw-wl-wishlistButtonSettings-style={branding.wishlistButtonSettings
        .style}
    style:--gw-wl-wishlistDrawerAndPageSettings-drawerPosition={branding
        .wishlistDrawerAndPageSettings.drawerPosition}
    style:--gw-wl-wishlistDrawerAndPageSettings-launcherBackgroundColor={branding
        .wishlistDrawerAndPageSettings.launcherBackgroundColor}
    style:--gw-wl-wishlistDrawerAndPageSettings-launcherFontColor={branding
        .wishlistDrawerAndPageSettings.launcherFontColor}
    style:--gw-wl-wishlistDrawerAndPageSettings-launcherIconBackgroundColor={theme[
        branding.wishlistDrawerAndPageSettings.launcherIconBackgroundColor
    ]}
    style:--gw-wl-wishlistDrawerAndPageSettings-buttonsColor={theme[
        branding.wishlistDrawerAndPageSettings.buttonsColor
    ]}
    style:--gw-wl-wishlistDrawerAndPageSettings-buttonsFontColor={branding
        .wishlistDrawerAndPageSettings.buttonsFontColor}
    style:--gw-wl-wishlistDrawerAndPageSettings-buttonsStyle={branding
        .wishlistDrawerAndPageSettings.buttonsStyle}
    style:--gw-wl-wishlistDrawerAndPageSettings-buttonsBorderRadius={branding
        .wishlistDrawerAndPageSettings.buttonsBorderRadius}
    style:--gw-wl-wishlistDrawerAndPageSettings-linkColor={theme[
        branding.wishlistDrawerAndPageSettings.linkColor
    ]}
>
    <slot />
</div>
